// src/utils/menuUtils.js

/**
 * 메뉴 데이터를 계층 구조 트리로 변환
 * @param {Array} menus - 평면 메뉴 배열
 * @returns {Array} root 메뉴 배열 (children 재귀 포함)
 */
export function buildMenuTree(menus) {
  if (!Array.isArray(menus)) return []

  // root 판정 공통 기준
  const isRoot = (upMenuId) => {
    return (
      !upMenuId ||
      upMenuId === '' ||
      upMenuId === 'MENU_00000' ||
      upMenuId === 'root'
    )
  }

  // 메뉴 ID → 메뉴 객체 맵
  const menuMap = new Map()
  menus.forEach(menu => {
    menuMap.set(menu.menuId, { ...menu, children: [] })
  })

  const rootMenus = []

  menus.forEach(menu => {
    const node = menuMap.get(menu.menuId)

    if (isRoot(menu.upMenuId)) {
      // 최상위 메뉴
      rootMenus.push(node)
    } else {
      const parent = menuMap.get(menu.upMenuId)
      if (parent) {
        parent.children.push(node)
      } else {
        rootMenus.push(node)
      }
    }
  })

  // sortSeq 기준 정렬
  const sortMenus = (list) => {
    list.sort((a, b) => (a.sortSeq || 0) - (b.sortSeq || 0))
    list.forEach(m => {
      if (m.children && m.children.length > 0) {
        sortMenus(m.children)
      }
    })
  }

  sortMenus(rootMenus)
  return rootMenus
}

/**
 * 메뉴 통계 정보
 */
export function getMenuStats(menus) {
  if (!Array.isArray(menus)) {
    return { total: 0, byLevel: {}, byDomain: {}, rootCount: 0 }
  }

  const stats = {
    total: menus.length,
    byLevel: {},
    byDomain: {},
    rootCount: 0
  }

  menus.forEach(menu => {
    const level = menu.level || 0
    stats.byLevel[level] = (stats.byLevel[level] || 0) + 1

    const domain = menu.dmnId || 'unknown'
    stats.byDomain[domain] = (stats.byDomain[domain] || 0) + 1

    if (!menu.upMenuId || menu.upMenuId === '' || menu.upMenuId === 'MENU_00000') {
      stats.rootCount++
    }
  })

  return stats
}

/**
 * 특정 메뉴의 breadcrumb 경로
 */
export function getMenuPath(menus, menuId) {
  if (!Array.isArray(menus) || !menuId) return []

  const menuMap = new Map()
  menus.forEach(menu => {
    menuMap.set(menu.menuId, menu)
  })

  const path = []
  let currentId = menuId
  const visited = new Set()

  while (currentId && !visited.has(currentId)) {
    visited.add(currentId)
    const current = menuMap.get(currentId)
    if (!current) break

    path.unshift({
      menuId: current.menuId,
      menuNm: current.menuNm,
      menuLink: current.menuLink,
      level: current.level || 0
    })

    currentId = current.upMenuId
  }

  return path
}
